import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type ThemeMode } from '../lib/theme';
import { IconButton } from './ui';

const NEXT: Record<ThemeMode, ThemeMode> = { system: 'light', light: 'dark', dark: 'system' };

const LABEL: Record<ThemeMode, string> = {
  system: 'Theme: follows your system',
  light: 'Theme: light',
  dark: 'Theme: dark',
};

/**
 * One button rather than a menu: the icon states what is active and the tooltip
 * names what a click will do, so the whole three-way choice stays in the header
 * without opening anything.
 */
export default function ThemeToggle({ className }: { className?: string }) {
  const { mode, cycleMode } = useTheme();
  const Icon = mode === 'light' ? Sun : mode === 'dark' ? Moon : Monitor;

  return (
    <IconButton
      label={`${LABEL[mode]} — switch to ${NEXT[mode]}`}
      variant="ghost"
      size="sm"
      className={className}
      onClick={cycleMode}
    >
      <Icon className="size-4" />
    </IconButton>
  );
}
